import oidc from '@/vue-oidc-client';

import charts from './charts';
import download from './download';
import projects from './projects';
import reports from './reports';
import documents from './document';

const PMMain = () => import('@/pages/ProjectManagementPage.vue');

const baseMeta = {
    authName: oidc.authName,
    permissions: [],
};

export default [
    {
        name: 'projectManagement',
        path: '/project-management',
        component: PMMain,
        meta: baseMeta,
        children: [...charts, ...projects, ...reports, ...documents],
    },

    ...download,
];
